import { createSlice } from "@reduxjs/toolkit";
import { fetchUnitsList, fetchBaseUnitsList, createOrUpdateUnit, deleteUnit } from "./unitsThunks";

const unitsSlice = createSlice({
  name: "units",
  initialState: {
  units: [],
  baseUnits: [],
  loading: false,
  error: null,
  successMessage: null,
  selectedUnit: null,
  isEditUnit: false,
},

  reducers: {
  resetUnitManageStatus: (state) => {
    state.successMessage = null;
  },
  setSelectedUnit: (state, action) => {
    state.selectedUnit = action.payload;
  },
  setIsEditUnit: (state, action) => {
    state.isEditUnit = action.payload;
  },
},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnitsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnitsList.fulfilled, (state, action) => {
        state.loading = false;
        state.units = action.payload;
      })
      .addCase(fetchBaseUnitsList.fulfilled, (state, action) => {
        state.baseUnits = action.payload;
      })
      .addCase(createOrUpdateUnit.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { resetUnitManageStatus, setSelectedUnit, setIsEditUnit} = unitsSlice.actions;
export default unitsSlice.reducer;
